import React from 'react';
export const ContextApp = React.createContext();